import { useEffect, useState, useContext, useCallback } from "react";
import ViewSummary from "./view_summary";
import { Box } from "@material-ui/core";
import AssigmentFilterModal from "./AssigmentFilterModal";
import MIFeedbackModal from "./MIFeedbackModal";
import ServiceTypeFilter from "./Filters/ServiceTypeFilter";
import { MIContext } from "./MIContext";
import DatePickerFilter from "./Filters/DatePickerFilter";
import FilterCard from "./Filters/FilterCard";
import MITable from "./MITable";
import useFetchMI from "./Hooks/useFetchMI";
import ServiceFilter from "./Filters/ServiceFilter";
import { useSelector } from "react-redux";

function MI() {
  const {
    dateFilter,
    setDateFilter,
    setOrganisationID,
    service,
    setService,
    serviceType,
    setServiceType,
    statisticsFilter,
    setStatisticsFilter,
  } = useContext(MIContext);

  const globaluserData = useSelector((state) => state.commonReducer);

  const role = globaluserData.role;
  const orgID = globaluserData.organisation_id;

  if (!(role === "admin")) {
    setOrganisationID(orgID);
  }

  const { refetchMITable, isRefetchingMiTable } = useFetchMI();

  return (
    <Box my={4} mx={8}>
      <Box display={"flex"} gridColumnGap={"2rem"}>
        <ServiceTypeFilter
          serviceType={serviceType}
          setServiceType={setServiceType}
        />
        <ServiceFilter setService={setService} service={service} />
      </Box>
      <br />
      <br />

      <br />
      <br />
      <FilterCard
        statisticsFilter={statisticsFilter}
        setStatisticsFilter={setStatisticsFilter}
      />
      <DatePickerFilter dateFilter={dateFilter} setDateFilter={setDateFilter} />
      <MITable
        refetchMITable={refetchMITable}
        isRefetchingMiTable={isRefetchingMiTable}
      />
      <ViewSummary />
      <AssigmentFilterModal />
      <MIFeedbackModal />
    </Box>
  );
}

export default MI;
